<template>
  <v-layout
    v-if="loading"
    style="position: absolute; top: 0; left: 0"
    :style="{
      'z-index': zIndex,
      background: backgroundColor,
      'pointer-events': pointerEvents,
      width: width,
      height: height,
    }"
  >
    <v-layout
      justify-center
      :style="{
        'padding-top': paddingTop,
      }"
    >
      <v-progress-circular
        indeterminate
        class="mt-5"
        :class="indicatorClass"
        :size="size"
      />
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    zIndex: {
      type: Number,
      default: 2,
    },
    indicatorClass: {
      type: String,
      default: 'msr--text',
    },
    backgroundOpacity: {
      type: Number,
      default: 0.5,
    },
    blocking: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    },
    size: {
      type: Number,
      default: 64,
    },
    paddingTop: {
      type: String,
      default: '40%',
    },
  },
  computed: {
    backgroundColor() {
      return 'rgba(255, 255, 255, ' + this.backgroundOpacity + ')';
    },
    pointerEvents() {
      if (this.blocking) {
        return 'all';
      }
      return 'none';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/FullpageLoadingIndicator.vue